import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "profile user_profile"
};
const _hoisted_3 = { class: "wrapper_1" };
const _hoisted_4 = { class: "inner" };
const _hoisted_5 = { class: "prof_1" };
const _hoisted_6 = { class: "ph" };
const _hoisted_7 = { class: "name_box" };
const _hoisted_8 = { class: "name" };
const _hoisted_9 = { class: "advice cel2" };
const _hoisted_10 = {
    key: 0,
    class: "prof_ranking"
};
const _hoisted_11 = { class: "r_1" };
const _hoisted_12 = {
    class: "r_2",
    style: { "margin-left": "6px" }
};
const _hoisted_13 = {
    class: "r_3",
    style: { "margin-left": "6px" }
};
const _hoisted_14 = {
    class: "star",
    style: { "margin-left": "6px" }
};
const _hoisted_15 = ["data-rate"];
const _hoisted_16 = {
    class: "heart",
    style: { "margin-left": "6px" }
};
const _hoisted_17 = { class: "prof_2" };
const _hoisted_18 = { class: "f_box" };
const _hoisted_19 = { class: "f_l" };
const _hoisted_20 = { class: "f_box" };
const _hoisted_21 = { class: "f_l" };
const _hoisted_22 = { class: "bread" };
const _hoisted_23 = { key: 0 };
const _hoisted_24 = { key: 1 };
const _hoisted_25 = { key: 2 };
const _hoisted_26 = { key: 3 };
const _hoisted_27 = { class: "f_box" };
const _hoisted_28 = { class: "f_l" };
const _hoisted_29 = { style: { "white-space": "pre-line" } };
const _hoisted_30 = { class: "f_box" };
const _hoisted_31 = { class: "f_l" };
const _hoisted_32 = { class: "f_box" };
const _hoisted_33 = { class: "f_l" };
const _hoisted_34 = { class: "f_box" };
const _hoisted_35 = { class: "f_l" };
const _hoisted_36 = { class: "f_box" };
const _hoisted_37 = { class: "f_l" };
const _hoisted_38 = { class: "f_box" };
const _hoisted_39 = { class: "f_l" };
const _hoisted_40 = { class: "f_box" };
const _hoisted_41 = { class: "f_l" };
const _hoisted_42 = { class: "f_box" };
const _hoisted_43 = { class: "f_l" };
const _hoisted_44 = { class: "under_line" };
const _hoisted_45 = { class: "f_box" };
const _hoisted_46 = { class: "f_l max" };
const _hoisted_47 = { class: "job" };
const _hoisted_48 = { class: "w100" };
const _hoisted_49 = { class: "w100" };
const _hoisted_50 = { class: "w50" };
const _hoisted_51 = { class: "w50" };
const _hoisted_52 = { class: "w100" };
import { onMounted, nextTick } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import Formatter from '@util/Formatter';
import { AuthRole, QuestionType, UserLeaveState } from '@util/Consts';
import ImageFrame from '@component/ImageFrame.vue';
const USER_HOME_SEARCH_SESSION_KEY = 'user-home-search';
export default /*@__PURE__*/ _defineComponent({
    __name: 'user_profile',
    props: {
        common: {},
        user: {}
    },
    setup(__props) {
        const props = __props;
        const onClickUserHome = () => {
            var _a, _b;
            let searchForm = JSON.parse(sessionStorage.getItem(USER_HOME_SEARCH_SESSION_KEY));
            if (searchForm) {
                searchForm.question_type_id = "";
                searchForm.industry_id = "";
                searchForm.job_group_id = "";
                searchForm.job_group_name = "";
                searchForm.job_id = "";
                searchForm.other_job_name = "";
                searchForm.option_type = "4";
                searchForm.keyword = `user:${(_a = props.user) === null || _a === void 0 ? void 0 : _a.id}`;
                sessionStorage.setItem(USER_HOME_SEARCH_SESSION_KEY, JSON.stringify(searchForm));
            }
            Inertia.get(route('question.index'), { option_type: QuestionType.HIGHLY_RATED, keyword: `user:${(_b = props.user) === null || _b === void 0 ? void 0 : _b.id}` });
        };
        const isLeavedFilter = (value) => {
            var _a;
            if (!value || UserLeaveState.UNPAID_LEAVE < ((_a = props.user) === null || _a === void 0 ? void 0 : _a.leave_state))
                return '';
            return value;
        };
        onMounted(() => {
            nextTick(() => {
                require('@jquery/active');
            });
        });
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11;
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _cache[22] || (_cache[22] = _createElementVNode("h2", null, "ユーザー情報", -1)),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("div", _hoisted_6, [
                                        _createVNode(ImageFrame, {
                                            src: props.user.photo
                                        }, null, 8, ["src"])
                                    ]),
                                    _createElementVNode("div", _hoisted_7, [
                                        _createElementVNode("div", _hoisted_8, _toDisplayString(props.user.name), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_9, [
                                        _createElementVNode("a", {
                                            onClick: _withModifiers(onClickUserHome, ["prevent"])
                                        }, [
                                            _cache[1] || (_cache[1] = _createTextVNode("相談")),
                                            _createElementVNode("p", null, [
                                                _createElementVNode("span", null, _toDisplayString((_b = (_a = props.user) === null || _a === void 0 ? void 0 : _a.question_count) !== null && _b !== void 0 ? _b : 0), 1),
                                                _cache[0] || (_cache[0] = _createTextVNode("件"))
                                            ])
                                        ]),
                                        (props.user.role === _unref(AuthRole).MENTOR)
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 0,
                                                onClick: _withModifiers(onClickUserHome, ["prevent"]),
                                                style: { "margin-left": "6px" }
                                            }, [
                                                _cache[3] || (_cache[3] = _createTextVNode("回答")),
                                                _createElementVNode("p", null, [
                                                    _createElementVNode("span", null, _toDisplayString((_d = (_c = props.user) === null || _c === void 0 ? void 0 : _c.answer_count) !== null && _d !== void 0 ? _d : 0), 1),
                                                    _cache[2] || (_cache[2] = _createTextVNode("件"))
                                                ])
                                            ]))
                                            : _createCommentVNode("", true)
                                    ])
                                ]),
                                (props.user.role === _unref(AuthRole).MENTOR)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                        _createElementVNode("p", _hoisted_11, _toDisplayString((_f = (_e = props.user) === null || _e === void 0 ? void 0 : _e.first_place_count) !== null && _f !== void 0 ? _f : 0), 1),
                                        _createElementVNode("p", _hoisted_12, _toDisplayString((_h = (_g = props.user) === null || _g === void 0 ? void 0 : _g.second_place_count) !== null && _h !== void 0 ? _h : 0), 1),
                                        _createElementVNode("p", _hoisted_13, _toDisplayString((_k = (_j = props.user) === null || _j === void 0 ? void 0 : _j.third_place_count) !== null && _k !== void 0 ? _k : 0), 1),
                                        _createElementVNode("p", _hoisted_14, [
                                            _cache[4] || (_cache[4] = _createTextVNode("評価")),
                                            _createElementVNode("span", {
                                                class: "star5_rating",
                                                "data-rate": (_m = (_l = props.user) === null || _l === void 0 ? void 0 : _l.evaluation_average) !== null && _m !== void 0 ? _m : 0
                                            }, null, 8, _hoisted_15)
                                        ]),
                                        _createElementVNode("p", _hoisted_16, [
                                            _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fas fa-heart" }, null, -1)),
                                            _createTextVNode(_toDisplayString((_p = (_o = props.user) === null || _o === void 0 ? void 0 : _o.like_count) !== null && _p !== void 0 ? _p : 0), 1)
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_17, [
                                    _createElementVNode("dl", null, [
                                        _cache[17] || (_cache[17] = _createElementVNode("dt", null, "業種", -1)),
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("div", _hoisted_18, [
                                                _createElementVNode("div", _hoisted_19, _toDisplayString((_r = (_q = props.user) === null || _q === void 0 ? void 0 : _q.industry) === null || _r === void 0 ? void 0 : _r.name), 1)
                                            ])
                                        ]),
                                        _cache[18] || (_cache[18] = _createElementVNode("dt", null, "職種", -1)),
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("div", _hoisted_20, [
                                                _createElementVNode("div", _hoisted_21, [
                                                    _createElementVNode("ul", _hoisted_22, [
                                                        ((_s = props.user.job_group) === null || _s === void 0 ? void 0 : _s.name)
                                                            ? (_openBlock(), _createElementBlock("li", _hoisted_23, _toDisplayString((_t = props.user.job_group) === null || _t === void 0 ? void 0 : _t.name), 1))
                                                            : _createCommentVNode("", true),
                                                        (!((_u = props.user.job_group) === null || _u === void 0 ? void 0 : _u.name) && ((_v = props.user) === null || _v === void 0 ? void 0 : _v.other_job_name))
                                                            ? (_openBlock(), _createElementBlock("li", _hoisted_24, "その他 "))
                                                            : _createCommentVNode("", true),
                                                        ((_w = props.user.job) === null || _w === void 0 ? void 0 : _w.name)
                                                            ? (_openBlock(), _createElementBlock("li", _hoisted_25, _toDisplayString((_x = props.user.job) === null || _x === void 0 ? void 0 : _x.name), 1))
                                                            : _createCommentVNode("", true),
                                                        (!((_y = props.user.job_group) === null || _y === void 0 ? void 0 : _y.name) && ((_z = props.user) === null || _z === void 0 ? void 0 : _z.other_job_name))
                                                            ? (_openBlock(), _createElementBlock("li", _hoisted_26, _toDisplayString((_0 = props.user) === null || _0 === void 0 ? void 0 : _0.other_job_name), 1))
                                                            : _createCommentVNode("", true)
                                                    ])
                                                ])
                                            ])
                                        ]),
                                        _cache[19] || (_cache[19] = _createElementVNode("dt", null, "会社概要", -1)),
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("div", _hoisted_27, [
                                                _createElementVNode("div", _hoisted_28, [
                                                    _createElementVNode("p", _hoisted_29, _toDisplayString(isLeavedFilter((_1 = props.user) === null || _1 === void 0 ? void 0 : _1.company_profile)), 1)
                                                ])
                                            ])
                                        ]),
                                        _cache[20] || (_cache[20] = _createElementVNode("dt", null, "年商", -1)),
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("div", _hoisted_30, [
                                                _createElementVNode("div", _hoisted_31, _toDisplayString(isLeavedFilter((_3 = (_2 = props.user) === null || _2 === void 0 ? void 0 : _2.annual_sale) === null || _3 === void 0 ? void 0 : _3.name)), 1)
                                            ])
                                        ]),
                                        _cache[21] || (_cache[21] = _createElementVNode("dt", null, "社員数", -1)),
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("div", _hoisted_32, [
                                                _createElementVNode("div", _hoisted_33, _toDisplayString(isLeavedFilter((_5 = (_4 = props.user) === null || _4 === void 0 ? void 0 : _4.employee) === null || _5 === void 0 ? void 0 : _5.name)), 1)
                                            ])
                                        ]),
                                        (((_6 = props.user) === null || _6 === void 0 ? void 0 : _6.role) === _unref(AuthRole).MENTOR)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _cache[11] || (_cache[11] = _createElementVNode("dt", null, "自己紹介", -1)),
                                                _createElementVNode("dd", null, [
                                                    _createElementVNode("div", _hoisted_34, [
                                                        _createElementVNode("div", _hoisted_35, [
                                                            _createElementVNode("p", null, _toDisplayString(isLeavedFilter((_7 = props.user) === null || _7 === void 0 ? void 0 : _7.self_introduction)), 1)
                                                        ])
                                                    ])
                                                ]),
                                                _cache[12] || (_cache[12] = _createElementVNode("dt", null, "スキル要約", -1)),
                                                _createElementVNode("dd", null, [
                                                    _createElementVNode("div", _hoisted_36, [
                                                        _createElementVNode("div", _hoisted_37, [
                                                            _createElementVNode("p", null, _toDisplayString(isLeavedFilter((_8 = props.user) === null || _8 === void 0 ? void 0 : _8.skill_summary)), 1)
                                                        ])
                                                    ])
                                                ]),
                                                _cache[13] || (_cache[13] = _createElementVNode("dt", null, "最終学歴", -1)),
                                                _createElementVNode("dd", null, [
                                                    _createElementVNode("div", _hoisted_38, [
                                                        _createElementVNode("div", _hoisted_39, _toDisplayString(isLeavedFilter((_9 = props.user) === null || _9 === void 0 ? void 0 : _9.education)), 1)
                                                    ])
                                                ]),
                                                _cache[14] || (_cache[14] = _createElementVNode("dt", null, "資格", -1)),
                                                _createElementVNode("dd", null, [
                                                    _createElementVNode("div", _hoisted_40, [
                                                        _createElementVNode("div", _hoisted_41, _toDisplayString(isLeavedFilter((_10 = props.user) === null || _10 === void 0 ? void 0 : _10.qualification)), 1)
                                                    ])
                                                ]),
                                                _cache[15] || (_cache[15] = _createElementVNode("dt", null, "語学", -1)),
                                                _createElementVNode("dd", null, [
                                                    _createElementVNode("div", _hoisted_42, [
                                                        _createElementVNode("div", _hoisted_43, _toDisplayString(isLeavedFilter((_11 = props.user) === null || _11 === void 0 ? void 0 : _11.language)), 1)
                                                    ])
                                                ]),
                                                _cache[16] || (_cache[16] = _createElementVNode("dt", null, "職歴", -1)),
                                                _createElementVNode("dd", _hoisted_44, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.user.careers, (value) => {
                                                        return (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                                            _createElementVNode("div", _hoisted_46, [
                                                                _createElementVNode("div", _hoisted_47, [
                                                                    _createElementVNode("div", _hoisted_48, [
                                                                        _cache[6] || (_cache[6] = _createElementVNode("p", { class: "sub_t" }, "期間", -1)),
                                                                        _createTextVNode(" " + _toDisplayString(isLeavedFilter(_unref(Formatter).formatCareerPeriod(value.started_at, value.ended_at))), 1)
                                                                    ]),
                                                                    _createElementVNode("div", _hoisted_49, [
                                                                        _cache[7] || (_cache[7] = _createElementVNode("p", { class: "sub_t" }, "組織", -1)),
                                                                        _createTextVNode(" " + _toDisplayString(isLeavedFilter(value.organization)), 1)
                                                                    ]),
                                                                    _createElementVNode("div", _hoisted_50, [
                                                                        _cache[8] || (_cache[8] = _createElementVNode("p", { class: "sub_t" }, "部署", -1)),
                                                                        _createTextVNode(" " + _toDisplayString(isLeavedFilter(value.department)), 1)
                                                                    ]),
                                                                    _createElementVNode("div", _hoisted_51, [
                                                                        _cache[9] || (_cache[9] = _createElementVNode("p", { class: "sub_t" }, "役職", -1)),
                                                                        _createTextVNode(" " + _toDisplayString(isLeavedFilter(value.position)), 1)
                                                                    ]),
                                                                    _createElementVNode("div", _hoisted_52, [
                                                                        _cache[10] || (_cache[10] = _createElementVNode("p", { class: "sub_t" }, "経験内容", -1)),
                                                                        _createTextVNode(" " + _toDisplayString(isLeavedFilter(value.experience_content)), 1)
                                                                    ])
                                                                ])
                                                            ])
                                                        ]));
                                                    }), 256))
                                                ])
                                            ], 64))
                                            : _createCommentVNode("", true)
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
